(function () {
  var section = document.querySelector('[data-ghost-resources]');
  if (!section) return;

  var searchInput = section.querySelector('[data-resources-search]');
  var searchDropdown = section.querySelector('[data-resources-search-dropdown]');
  var searchResults = section.querySelector('[data-resources-search-results]');
  var guidesRoot = section.querySelector('[data-resources-guides-root]');
  var guidesSearchView = section.querySelector('[data-resources-guides-search]');
  var videoGrid = section.querySelector('[data-resources-videos-grid]');
  var videoBanner = section.querySelector('[data-resources-video-banner]');
  var vaultVideoBanner = section.querySelector('[data-resources-vault-video-banner]');
  var vaultVideoGrid = section.querySelector('[data-resources-vault-videos-grid]');
  var modal = section.querySelector('[data-resources-video-modal]');
  var modalTitle = section.querySelector('[data-resources-modal-title]');
  var modalLabel = section.querySelector('[data-resources-modal-label]');
  var modalDescription = section.querySelector('[data-resources-modal-description]');
  var modalFrame = section.querySelector('[data-resources-modal-frame]');
  var modalClose = section.querySelector('[data-resources-modal-close]');
  var openGuideId = null;

  function closeModal() {
    if (!modal) return;
    modal.hidden = true;
    document.body.style.overflow = '';
    if (modalFrame) modalFrame.src = '';
  }

  function openModal(card) {
    if (!modal || !modalFrame) return;
    var uuid = card.getAttribute('data-video-uuid');
    var title = card.getAttribute('data-video-title') || '';
    var description = card.getAttribute('data-video-description') || '';
    var index = card.getAttribute('data-video-index') || '0';

    if (modalTitle) modalTitle.textContent = title;
    if (modalLabel) modalLabel.textContent = Number(index) === 0 ? 'Start Here' : 'Video ' + (Number(index) + 1);
    if (modalDescription) modalDescription.textContent = description;
    modalFrame.src = 'https://play.vidyard.com/' + uuid + '?autoplay=1';
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
  }

  function getGuides() {
    return Array.prototype.slice.call(section.querySelectorAll('[data-guide-id]'));
  }

  function guideMatches(guide, query) {
    var haystack = guide.getAttribute('data-guide-search') || '';
    return haystack.indexOf(query) !== -1;
  }

  function renderSearchResults(query) {
    if (!searchResults || !searchDropdown) return;
    searchResults.innerHTML = '';
    var matches = getGuides().filter(function (guide) {
      return guideMatches(guide, query);
    }).slice(0, 5);

    if (matches.length === 0) {
      var empty = document.createElement('p');
      empty.className = 'ghost-resources__search-empty';
      empty.textContent = section.getAttribute('data-no-results-text') || 'No guides found.';
      searchResults.appendChild(empty);
      searchDropdown.hidden = false;
      return;
    }

    matches.forEach(function (guide) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'ghost-resources__search-result';
      button.setAttribute('data-search-result', guide.getAttribute('data-guide-id'));

      var title = guide.querySelector('.ghost-resources__guide-title');
      var problem = guide.querySelector('.ghost-resources__guide-problem');

      var titleEl = document.createElement('span');
      titleEl.className = 'ghost-resources__search-result-title';
      titleEl.textContent = title ? title.textContent : '';

      var problemEl = document.createElement('span');
      problemEl.className = 'ghost-resources__search-result-problem';
      problemEl.textContent = problem ? problem.textContent : '';

      button.appendChild(titleEl);
      button.appendChild(problemEl);
      searchResults.appendChild(button);
    });

    searchDropdown.hidden = false;
  }

  function setGuideOpen(guide, open) {
    if (!guide) return;
    var toggle = guide.querySelector('[data-guide-toggle]');
    var panel = guide.querySelector('[data-guide-panel]');
    guide.classList.toggle('is-open', open);
    if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (panel) panel.hidden = !open;
  }

  function openGuideById(id) {
    var guide = section.querySelector('[data-guide-id="' + id + '"]');
    if (!guide) return;

    if (openGuideId && openGuideId !== id) {
      setGuideOpen(section.querySelector('[data-guide-id="' + openGuideId + '"]'), false);
    }

    openGuideId = id;
    setGuideOpen(guide, true);

    window.setTimeout(function () {
      guide.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 100);
  }

  function applySearch(query) {
    var normalized = query.trim().toLowerCase();
    var isSearching = normalized.length > 0;

    if (guidesRoot) guidesRoot.hidden = isSearching;
    if (guidesSearchView) guidesSearchView.hidden = !isSearching;

    if (!isSearching) {
      if (searchDropdown) searchDropdown.hidden = true;
      return;
    }

    renderSearchResults(normalized);

    if (!guidesSearchView) return;
    guidesSearchView.innerHTML = '';

    var matches = getGuides().filter(function (guide) {
      return guideMatches(guide, normalized);
    });

    if (matches.length === 0) {
      var emptyWrap = document.createElement('div');
      emptyWrap.className = 'ghost-resources__guides-empty';
      emptyWrap.innerHTML = '<svg width="40" height="40" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" stroke="currentColor" stroke-width="1.5"/></svg><p>' + (section.getAttribute('data-no-guides-text') || 'No guides found.') + '</p>';
      guidesSearchView.appendChild(emptyWrap);
      return;
    }

    matches.forEach(function (guide) {
      guidesSearchView.appendChild(guide.cloneNode(true));
    });

    guidesSearchView.querySelectorAll('[data-guide-toggle]').forEach(function (toggle) {
      toggle.addEventListener('click', handleGuideToggle);
    });
  }

  function handleGuideToggle(event) {
    var toggle = event.currentTarget;
    var guide = toggle.closest('[data-guide-id]');
    if (!guide) return;

    var id = guide.getAttribute('data-guide-id');
    var panel = guide.querySelector('[data-guide-panel]');
    var willOpen = panel && panel.hidden;

    if (openGuideId && openGuideId !== id) {
      setGuideOpen(section.querySelector('[data-guide-id="' + openGuideId + '"]'), false);
    }

    openGuideId = willOpen ? id : null;
    setGuideOpen(guide, willOpen);
  }

  function handleFaqToggle(event) {
    var toggle = event.currentTarget;
    var item = toggle.closest('[data-faq-item]');
    if (!item) return;

    var panel = item.querySelector('[data-faq-panel]');
    var willOpen = panel && panel.hidden;

    section.querySelectorAll('[data-faq-item].is-open').forEach(function (openItem) {
      if (openItem === item) return;
      openItem.classList.remove('is-open');
      var openToggle = openItem.querySelector('[data-faq-toggle]');
      var openPanel = openItem.querySelector('[data-faq-panel]');
      if (openToggle) openToggle.setAttribute('aria-expanded', 'false');
      if (openPanel) openPanel.hidden = true;
    });

    item.classList.toggle('is-open', willOpen);
    toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    if (panel) panel.hidden = !willOpen;
  }

  function handleCopyLink(event) {
    var button = event.currentTarget;
    var link = button.getAttribute('data-copy-link');
    if (!link || !navigator.clipboard) return;

    navigator.clipboard.writeText(link).then(function () {
      button.classList.add('is-copied');
      var label = button.querySelector('[data-copy-label]');
      if (label) label.textContent = section.getAttribute('data-copied-text') || 'Copied!';
      window.setTimeout(function () {
        button.classList.remove('is-copied');
        if (label) label.textContent = section.getAttribute('data-copy-text') || 'Copy link';
      }, 2000);
    });
  }

  if (videoBanner && videoGrid) {
    videoBanner.addEventListener('click', function () {
      videoGrid.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  if (vaultVideoBanner && vaultVideoGrid) {
    vaultVideoBanner.addEventListener('click', function () {
      vaultVideoGrid.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  section.querySelectorAll('[data-resources-group-banner]').forEach(function (banner) {
    banner.addEventListener('click', function () {
      var targetId = banner.getAttribute('data-resources-group-target');
      var grid = targetId
        ? section.querySelector('[data-resources-group-grid="' + targetId + '"]')
        : banner.parentElement && banner.parentElement.querySelector('[data-resources-group-grid]');
      if (grid) grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  section.querySelectorAll('[data-video-open]').forEach(function (button) {
    button.addEventListener('click', function () {
      var card = button.closest('[data-video-uuid]');
      if (card) openModal(card);
    });
  });

  section.querySelectorAll('[data-copy-link]').forEach(function (button) {
    button.addEventListener('click', function (event) {
      event.stopPropagation();
      handleCopyLink(event);
    });
  });

  section.querySelectorAll('[data-guide-toggle]').forEach(function (toggle) {
    toggle.addEventListener('click', handleGuideToggle);
  });

  section.querySelectorAll('[data-faq-toggle]').forEach(function (toggle) {
    toggle.addEventListener('click', handleFaqToggle);
  });

  if (searchInput) {
    searchInput.addEventListener('input', function () {
      applySearch(searchInput.value);
    });

    searchInput.addEventListener('focus', function () {
      if (searchInput.value.trim().length > 0) applySearch(searchInput.value);
    });
  }

  section.addEventListener('click', function (event) {
    var result = event.target.closest('[data-search-result]');
    if (result) {
      openGuideById(result.getAttribute('data-search-result'));
      if (searchInput) searchInput.value = '';
      applySearch('');
      return;
    }

    if (searchDropdown && searchInput && !event.target.closest('[data-resources-search-wrap]')) {
      searchDropdown.hidden = true;
    }
  });

  if (modalClose) modalClose.addEventListener('click', closeModal);
  if (modal) {
    modal.addEventListener('click', function (event) {
      if (event.target === modal) closeModal();
    });
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeModal();
  });
})();
